// src/data/servicesData.js

import basketball from "../assets/services/service/basketball.jpg";
import tennis from "../assets/services/service/tennis.webp";
import running from "../assets/services/service/running-track.webp";
import wooden from "../assets/services/service/wooden-flooring.webp";
import epdm from "../assets/services/service/epdm.jpg";
import badminton from "../assets/services/service/badminton.webp";
import volleyball from "../assets/services/service/volleyball.webp";
import football from "../assets/services/service//football.webp";
const servicesData = [
  {
    id: 1,

    title: "Basketball Courts",

    slug: "basketball-court",

    category: "Outdoor",

    image: basketball,

    shortDescription:
      "Professional Acrylic, PU & Wooden Basketball Court Construction.",

    featured: true,

    route: "/services/basketball-court",
  },

  {
    id: 2,

    title: "Tennis Courts",

    slug: "tennis-court",

    category: "Outdoor",

    image: tennis,

    shortDescription:
      "ITF Standard Tennis Courts with Acrylic & Synthetic Surfaces.",

    featured: true,

    route: "/services/tennis-court",
  },

  {
    id: 3,

    title: "Running Tracks",

    slug: "running-track",

    category: "Athletics",

    image: running,

    shortDescription: "Synthetic Athletic Running Track Construction.",

    featured: true,

    route: "/services/running-track",
  },

  {
    id: 4,

    title: "Wooden-Flooring",

    category: "Flooring",

    slug: "wooden-flooring",

    image: wooden,

    shortDescription: "Premium Wooden-Flooring for Sports Grounds.",

    featured: true,

    route: "/services/wooden-flooring",
  },

  {
    id: 5,

    title: "EPDM Flooring",

    category: "Flooring",

    slug: "epdm-flooring",

    image: epdm,

    shortDescription: "Premium Rubber Safety Flooring for Play Areas.",

    featured: true,

    route: "/services/epdm-flooring",
  },

  {
    id: 6,

    title: "Badminton Courts",

    category: "Indoor",

    slug: "badminton-court",

    image: badminton,

    shortDescription: "Indoor & Outdoor Badminton Court Construction.",

    featured: true,

    route: "/services/badminton-court",
  },

  {
    id: 7,

    title: "Volleyball Courts",

    category: "Outdoor",

    slug: "volleyball-court",

    image: volleyball,

    shortDescription: "Professional Volleyball Court Construction.",

    featured: true,

    route: "/services/volleyball-court",
  },

  {
    id: 7,

    title: "Football Field",

    category: "Outdoor",

    slug: "football-court",

    image: football,

    shortDescription: "Professional Football Field Construction.",

    featured: true,

    route: "/services/football-field",
  },
];

export default servicesData;
